<script lang="ts">
    import {dyData, modal, analytics} from 'general/store';
    import {TEMPLATE, FLAGS} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import Logo from 'general/components/logo/Logo.svelte';
    import ScrollItem from 'general/components/scrollItem/ScrollItem.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import DyButton from 'general/components/dyButton/DyButton.svelte';

    import s from './style.module.css';
</script>

<ScrollItem>
    <div class={s.main} style="margin-top: {$dyData.side.typ?.marginTop || 0}">
        <Logo side="typ" />
        <Description template={TEMPLATE.SQUARE} value={$dyData.description?.typ} />
        {#if $dyData.flag === FLAGS.YOUTUBE && $dyData.actionButton?.typ}
            <ActionButton
                pointer={true}
                handleClick={modal.close}
                color="gray"
                fontSize="15px"
                lineHeight="23px"
                children="Continue shopping"
                {...$dyData.actionButton.typ}
            />
        {:else}
            <DyButton
                type="button"
                children="Continue Shopping"
                onClick={modal.close}
                eventLabel={$analytics?.onClickEventLabel}
                {...$dyData.mainButton?.typ}
            />
        {/if}
    </div>
</ScrollItem>
